import React from "react";

function WakeUp11111() {
	return (
		<div className="iframe_box">
			<iframe title="wakeup11111" id="mainframe" src="/wakeup11111.html" width="100%"></iframe>
		</div>
	)
}

export default WakeUp11111;